export function getPostLoginPath({ userNavigations, allUserInstitutionIds, institutionId, urlOnLogin }) {
  if (allUserInstitutionIds?.length > 1 && !institutionId) return '/institutions/all';
  if (urlOnLogin?.startsWith('/') && !urlOnLogin.startsWith('//')) return urlOnLogin;
  const firstLink = [...(userNavigations || [])].sort((a, b) =>
    (a.section_order - b.section_order) || (a.order - b.order)
  )[0]?.link;
  return firstLink ? `/${firstLink.replace(/^\/+/, '')}` : '/';
}
